import { create } from "zustand";

export type CorrectionDomain = "harvest" | "test";

interface CorrectionDialogState {
  open: boolean;
  domain: CorrectionDomain | null;
  /** The frozen revision to correct (harvest_operation_template.id / test_template_revision.id). */
  sourceRevisionId: number | null;
  /** Optional label for the dialog header. */
  title: string | null;
  /** Instances the dialog was opened for (a session or operation); null selects all. */
  preselectInstanceIds: number[] | null;
  openCorrection: (args: {
    domain: CorrectionDomain;
    sourceRevisionId: number;
    title?: string;
    preselectInstanceIds?: number[];
  }) => void;
  close: () => void;
}

export const useCorrectionDialogStore = create<CorrectionDialogState>((set) => ({
  open: false,
  domain: null,
  sourceRevisionId: null,
  title: null,
  preselectInstanceIds: null,
  openCorrection: ({ domain, sourceRevisionId, title, preselectInstanceIds }) =>
    set({
      open: true,
      domain,
      sourceRevisionId,
      title: title ?? null,
      preselectInstanceIds: preselectInstanceIds ?? null,
    }),
  close: () =>
    set({ open: false, domain: null, sourceRevisionId: null, title: null, preselectInstanceIds: null }),
}));
